import http from '@/requests/http'

class MemberCustomField {
  static all (params) {
    return http.post('configuration/member/custom-field/index', params)
  }
  static async view (params) {
    return http.post('configuration/member/custom-field/view', params)
  }
  static async update (data) {
    return http.post('configuration/member/custom-field/update', data)
  }
  static async save (data) {
    return http.post('configuration/member/custom-field/store', data)
  }
  static async destroy (id) {
    return http.post(`configuration/member/custom-field/delete/${id}`)
  }
}

export default MemberCustomField
